
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigation = [
    { name: 'Наши услуги', href: '#services' },
    { name: 'О нас', href: '#about' },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 滚动到联系区域
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // 通用滚动函数
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50 py-6">
      <nav className="mx-auto px-6 lg:px-12">
        <div className="bg-white/10 backdrop-blur-md rounded-full px-8 py-4 border border-white/20">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-medium text-white">
                Реклама / Дизайн / Фотография
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              {navigation.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href.replace('#', ''))}
                  className="text-white/90 hover:text-white font-light transition-colors cursor-pointer"
                >
                  {item.name}
                </button>
              ))}
              <button 
                onClick={scrollToContact}
                className="bg-white/20 text-white px-6 py-2 text-sm font-light hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer rounded-full border border-white/30"
              >
                Оставить заявку
              </button>
            </div>

            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-white hover:text-white/80 cursor-pointer"
              >
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="md:hidden border-t border-white/20 mt-4 pt-4">
              <div className="space-y-4">
                {navigation.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => {
                      scrollToSection(item.href.replace('#', ''));
                      setIsMenuOpen(false);
                    }}
                    className="block text-white/90 hover:text-white font-light cursor-pointer w-full text-left"
                  >
                    {item.name}
                  </button>
                ))}
                <button 
                  onClick={scrollToContact}
                  className="w-full bg-white/20 text-white px-6 py-2 text-sm font-light hover:bg-white/30 transition-colors cursor-pointer rounded-full border border-white/30"
                >
                  Оставить заявку
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}
